import { Identifiable, Resource, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

type Response = {
  _embedded: {
    resources: LinkedResource<Identifiable<Resource>>[];
  };
};

function getZoneResources(httpClient: HttpClient, linker: Linker) {
  return ({ uuid }: Identifiable<Zone>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/resources/search/rsql?query=planzone.zones.uuid==${uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) =>
        _embedded.resources.map((resource) => ({
          ...resource,
          tags: resource.tags
            ? resource.tags.map((tag) => {
                // @ts-ignore
                return typeof tag === "string" ? { name: tag } : tag;
              })
            : [],
        })),
      )
      .then((promises) => Promise.all(promises))
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getZoneResources };
